import { useEffect, useMemo } from "react";

import uniq from "lodash/uniq";

import { useActivationProjectContext } from "app/pages/activation/context/Project/ProjectContext";
import { useIconsQuery } from "app/pages/activation/queries/useIconsQuery";
import type { ShortActivationSetSchema } from "app/pages/activation/types/api";

type UseFaviconsSchema = {
    activationSetList?: ShortActivationSetSchema[];
    enabled?: boolean;
};

export const useFavicons = ({ activationSetList, enabled = true }: UseFaviconsSchema) => {
    const { onFaviconsSet } = useActivationProjectContext();

    const domains = useMemo(() => {
        if (activationSetList && enabled) {
            return uniq(activationSetList.flatMap(({ allDomains }) => allDomains));
        }
    }, [activationSetList]);

    const { data: favicons, isLoading: isIconsLoad } = useIconsQuery(domains, !!domains?.length && enabled);

    useEffect(() => {
        if (favicons && !isIconsLoad) {
            onFaviconsSet(favicons);
        }
    }, [isIconsLoad]);

    return { favicons, isIconsLoad };
};
